import React, { useContext } from "react";
import { Answer } from "../Answer";
import classNames from "classnames";
import { QuestionContext } from "../../context";

interface AnswerUserProps {
    className?: string;
}

export function AnswerUser({ className }: AnswerUserProps) {
    const ctx = useContext(QuestionContext);
    if (ctx.type === "Mixed") return null;

    return (
        <Answer
            answer={ctx.data.answer}
            className={classNames("QuestionAnswerUser", className)}
        />
    );
}
